<template>
  <b-sidebar
    id="sidebar-send-letter"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Send Letter') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        enctype="multipart/form-data"
        @submit.prevent
      >
        <validation-observer ref="sendLetter">

          <!-- Direction -->
          <b-form-group
            :label="$t('File')"
            label-for="direction"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File')"
              rules="required|file-size:10"
            >
              <b-form-file
                v-model="file"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
                @change="handleFile"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Send Letter') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BSidebar, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, fileSize } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      file: null,
      base64: null,
      required,
      fileSize,
    }
  },
  computed: {
    letter() {
      return this.$store.state.letter.letter
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    handleFile(e) {
      const selectedFile = e.target.files[0]
      this.base64 = selectedFile
    },
    createBase64(fileObject) {
      const reader = new FileReader()
      reader.onload = e => {
        this.base64 = e.target.result
      }
      reader.readAsDataURL(fileObject)
    },
    clear(hide) {
      this.file = null
      hide()
    },
    submit(hide) {
      this.$refs.sendLetter.validate().then(success => {
        if (success) {
          this.$removeSwal(this, {
            id: this.letter.id,
            body: {
              letter_status: this.$store.state.staticModule.letterStatusPending,
              letter_file: this.base64,
            },
          }, 'letter/send', () => {
            this.$emit('refetchData')
          }, {
            confirmButtonText: 'Yes, send it!',
            successTitle: 'Send!',
            successText: 'Your file has been sent.',
            errorText: 'Your file has not been sent.',
          })
          hide()
        }
      })
    },
  },
}
</script>
